<template>
  <div>
    <div class="box">
      <el-page-header
        @back="$router.go(-1)"
        :content="content"
      ></el-page-header>
    </div>
    <el-card class="content mt20 bbb">
      <el-form
        label-position="left"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="150px"
        class="demo-ruleForm"
      >
        <el-form-item :label="$t('serialList.title')" prop="title">
          <el-input v-model="ruleForm.title"></el-input>
        </el-form-item>
        <el-form-item :label="$t('serialList.book_desc')" prop="book_desc">
          <div v-if="load">
            <SummerNote
              :id="'summernote1' + new Date().getTime()"
              v-model="ruleForm.book_desc"
            />
          </div>
          <!-- <el-input v-model="ruleForm.book_desc"></el-input> -->
        </el-form-item>
        <el-form-item :label="$t('serialList.cover')" prop="cover">
          <upload-img
            :limitMax="1"
            :file-list="ruleForm.cover"
            @changeImgList="changeImgList"
          ></upload-img>
          <p class="img-guide">
            최대 파일 크기: 300M, 이미지 최적 사이즈: 920px * 920px(1:1 비율
            권장)
          </p>
        </el-form-item>
        <el-form-item :label="$t('serialList.detail')" prop="detail">
          <div v-if="load">
            <SummerNote
              :id="'summernote' + new Date().getTime()"
              v-model="ruleForm.detail"
            />
          </div>
        </el-form-item>
        <el-form-item :label="$t('serialList.tag')" prop="tag">
          <el-tag
            :key="tag"
            v-for="tag in ruleForm.tag"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)"
          >
            {{ tag }}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          >
          </el-input>
          <el-button
            v-else
            class="button-new-tag"
            size="small"
            @click="showInput"
            >+ New Tag</el-button
          >
        </el-form-item>
        <!-- <el-form-item :label="$t('serialList.day_of_week')" prop="day_of_week">
          <el-select
            v-model="ruleForm.day_of_week"
            multiple
            :placeholder="$t('please_select')"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item :label="$t('serialList.author_name')" prop="author_name">
          <el-input v-model="ruleForm.author_name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('serialList.author_desc')" prop="author_desc">
          <div v-if="load">
            <SummerNote
              :id="'summernote2' + new Date().getTime()"
              v-model="ruleForm.author_desc"
            />
          </div>
        </el-form-item>
        <el-form-item :label="$t('serialList.author_img')" prop="author_img">
          <upload-img
            :limitMax="1"
            :file-list="ruleForm.author_img"
            @changeImgList="changeImgList1"
          ></upload-img>
          <p class="img-guide">
            최대 파일 크기: 300M, 이미지 최적 사이즈: 260px * 260px(1:1 비율
            권장)
          </p>
        </el-form-item>
        <!-- <el-form-item :label="$t('serialList.is_recommend')" prop="is_recommend">
           <el-radio-group v-model="ruleForm.is_recommend">
                <el-radio :label="0">{{$t('serialList.recommend0')}}</el-radio>
                <el-radio :label="1">{{$t('serialList.recommend1')}}</el-radio>
            </el-radio-group>
        </el-form-item> -->
        <!-- <el-form-item
          :label="$t('serialList.is_switch_on')"
          prop="is_switch_on"
        >
          <el-radio-group v-model="ruleForm.is_switch_on">
            <el-radio :label="0">{{ $t('serialList.switch_on0') }}</el-radio>
            <el-radio :label="1">{{ $t('serialList.switch_on1') }}</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <!-- <el-form-item :label="$t('serialList.status')" prop="status">
          <el-radio-group v-model="ruleForm.status">
            <el-radio :label="0">{{ $t('serialList.status0') }}</el-radio>
            <el-radio :label="1">{{ $t('serialList.status1') }}</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <!-- <el-form-item
          v-if="ruleForm.status === 1"
          :label="$t('serialList.link')"
          prop="link"
        >
          <el-input v-model="ruleForm.link"></el-input>
        </el-form-item> -->
        <el-form-item :label="$t('serialList.active')" prop="active">
          <el-radio-group v-model="ruleForm.active">
            <el-radio :label="0">{{ $t('serialList.active0') }}</el-radio>
            <el-radio :label="1">{{ $t('serialList.active1') }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <el-button class="btn" type="primary" @click="submitForm('ruleForm')">{{
        $t('btnTip.submit')
      }}</el-button>
    </el-card>
  </div>
</template>
<script>
import uploadImg from '@/components/uploadImg';
import SummerNote from '@/components/summernote';
import { serialDetail, addSerial, editSerial } from '@/api/api';
export default {
  name: 'editSerial',
  data() {
    var validatePass = (rule, value, callback) => {
      const reg = /http[s]{0,1}:\/\/([\w.]+\/?)\S*/;
      if (reg.test(value) || value === '' || value === null) {
        callback();
      } else {
        callback(new Error(this.$t('carouselManagement').urlRule));
      }
    };
    return {
      ruleForm: {
        title: '',
        detail: '',
        cover: '',
        book_desc: '',
        author_name: '',
        author_desc: '',
        day_of_week: [],
        author_img: '',
        is_recommend: 0,
        is_switch_on: 0,
        status: 1,
        link: '',
        active: '',
        tag: [],
      },
      inputVisible: false,
      inputValue: '',
      rules: {
        title: [
          {
            required: true,
            message: this.$t('serialList').title,
            trigger: 'blur',
          },
        ],
        detail: [
          {
            required: true,
            message: this.$t('serialList').detail,
            trigger: 'blur',
          },
        ],
        cover: [
          {
            required: true,
            message: this.$t('serialList').cover,
            trigger: 'blur',
          },
        ],
        book_desc: [
          {
            required: false,
            message: this.$t('serialList').book_desc,
            trigger: 'blur',
          },
        ],
        author_name: [
          {
            required: true,
            message: this.$t('serialList').author_name,
            trigger: 'blur',
          },
        ],
        author_desc: [
          {
            required: false,
            message: this.$t('serialList').author_desc,
            trigger: 'blur',
          },
        ],
        // day_of_week: [
        //   {
        //     required: false,
        //     message: this.$t('serialList').day_of_week,
        //     trigger: 'blur',
        //   },
        // ],
        author_img: [
          {
            required: false,
            message: this.$t('serialList').author_img,
            trigger: 'blur',
          },
        ],
        // is_recommend: [
        //   {
        //     required: true,
        //     message: this.$t("serialList").is_recommend,
        //     trigger: "blur",
        //   },
        // ],
        // is_switch_on: [
        //   {
        //     required: true,
        //     message: this.$t('serialList').is_switch_on,
        //     trigger: 'blur',
        //   },
        // ],
        // status: [
        //   {
        //     required: true,
        //     message: this.$t('serialList').status,
        //     trigger: 'blur',
        //   },
        // ],
        // link: [
        //   {
        //     required: false,
        //     validator: validatePass,
        //     message: this.$t('carouselManagement').urlRule,
        //     trigger: 'blur',
        //   },
        // ],
        active: [
          {
            required: true,
            message: this.$t('serialList').active,
            trigger: 'blur',
          },
        ],
      },
      options: [
        { label: this.$t('day1'), value: 0 },
        { label: this.$t('day2'), value: 1 },
        { label: this.$t('day3'), value: 2 },
        { label: this.$t('day4'), value: 3 },
        { label: this.$t('day5'), value: 4 },
      ],
      load: false,
    };
  },
  components: {
    SummerNote,
    uploadImg,
  },
  computed: {
    id() {
      return Number.isNaN(Number(this.$route.query.id))
        ? undefined
        : Number(this.$route.query.id);
    },
    content() {
      return this.id === undefined
        ? this.$t('btnTip').add
        : this.$t('btnTip').edit;
    },
  },
  methods: {
    handleClose(tag) {
      this.ruleForm.tag.splice(this.ruleForm.tag.indexOf(tag), 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.ruleForm.tag.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    changeImgList(arr) {
      if (arr.length === 0) {
        this.ruleForm.cover = '';
      } else {
        this.ruleForm.cover = arr[0];
      }
    },
    changeImgList1(arr) {
      if (arr.length === 0) {
        this.ruleForm.author_img = '';
      } else {
        this.ruleForm.author_img = arr[0];
      }
    },
    async submitForm(formName) {
      await this.$refs[formName].validate();
      let ruleForm = { ...this.ruleForm };
      if (ruleForm.link === '') {
        ruleForm.link = null;
      }
      if (this.id === undefined) {
        await addSerial(ruleForm);
      } else {
        delete this.ruleForm.create_time;
        delete this.ruleForm.update_time;
        await editSerial(ruleForm);
      }
      this.$router.go(-1);
    },
    async get_info() {
      const information = await serialDetail(this.id);
      information.day_of_week = information.day_of_week.map((item) => {
        return +item;
      });
      this.ruleForm = { ...information };
      this.load = true;
    },
  },
  async created() {
    if (this.id === undefined) {
      this.load = true;
      return;
    }
    this.get_info();
  },
};
</script>
<style land="scss" scoped>
.el-date-editor {
  margin-right: 10px;
}
.bbb {
  position: relative;
  padding-bottom: 50px;
}
.bbb .btn {
  position: absolute;
  bottom: 10px;
  right: 20px;
}

.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

.img-guide {
  color: #808080;
}
</style>
